(function() {
    'use strict';

    angular.module('allegro').controller(
        'AllegroCreatePriceChangeCmdModalController', AllegroCreatePriceChangeCmdModalController);

    AllegroCreatePriceChangeCmdModalController.$inject = [
        '$uibModalInstance',
        'dataObj',
        'allegroOffersDataSrvc',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroOfferCmdConst',
        'allegroOfferCmdMessageConst'
    ];

    function AllegroCreatePriceChangeCmdModalController(
        $uibModalInstance, data, allegroOffersDataSrvc, notificationSrvc, errorNotificationSrvc,
        allegroOfferCmdConst, allegroOfferCmdMessageConst
    ) {
        var self = this;

        self.loading = false;
        self.data = data;
        self.saving = false;
        self.serverErrors = {
            modification: {
                type: [],
                operation: [],
                modificator: [],
                price: [],
                value: [],
                percentage: []
            }
        };

        self.ownPriceOpt = allegroOfferCmdConst.ownPriceOpt;
        self.modifyOwnPriceOpt = allegroOfferCmdConst.modifyOwnPriceOpt;
        self.modifyTypeOpts = allegroOfferCmdConst.modifyTypeOpts;
        self.additionOperationOpt = allegroOfferCmdConst.additionOperationOpt;
        self.substractOperationOpt = allegroOfferCmdConst.substractOperationOpt;
        self.operationOpts = allegroOfferCmdConst.operationOpts;
        self.priceModificatorOpt = allegroOfferCmdConst.priceModificatorOpt;
        self.percentageModificatorOpt = allegroOfferCmdConst.percentageModificatorOpt;
        self.modificatorOpts = allegroOfferCmdConst.modificatorOpts;

        self.modificationData = {
            type: self.ownPriceOpt,
            operation: self.additionOperationOpt,
            modificator: self.priceModificatorOpt
        }

        self.isOwnPriceOpt = isOwnPriceOpt;
        self.isOwnPriceSelected = isOwnPriceSelected;
        self.isModifyOwnPriceOpt = isModifyOwnPriceOpt;
        self.isModifyOwnPriceSelected = isModifyOwnPriceSelected;
        self.isPriceModificatorSelected = isPriceModificatorSelected;
        self.isPercentageModificatorSelected = isPercentageModificatorSelected;
        self.onChangeModifyType = onChangeModifyType;
        self.onChangeModificator = onChangeModificator;
        self.formSubmit = formSubmit;
        self.modalClose = modalClose;
        self.cleanErrors = cleanErrors;


        activate();

        function activate() {}

        function isOwnPriceOpt(opt){
            return self.ownPriceOpt === opt.value
        }

        function isOwnPriceSelected(){
            return self.modificationData.type === self.ownPriceOpt
        }

        function isModifyOwnPriceOpt(opt){
            return self.modifyOwnPriceOpt === opt.value
        }

        function isModifyOwnPriceSelected(){
            return self.modificationData.type === self.modifyOwnPriceOpt
        }

        function isPriceModificatorSelected(){
            return self.modificationData.modificator === self.priceModificatorOpt
        }

        function isPercentageModificatorSelected(){
            return self.modificationData.modificator === self.percentageModificatorOpt
        }

        function formSubmit() {
            self.saving = true;
            return allegroOffersDataSrvc.createPriceChangeCmd({
                    offers: self.data.offers,
                    type: 'PRICE_MODIFICATION',
                    modification: self.modificationData
                })
                .$promise
                .then(function (response) {
                    notificationSrvc.notification("success", allegroOfferCmdMessageConst.changePrice);
                    $uibModalInstance.close(response);
                })
                .catch(function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function () {
                    self.saving = false;
                });
        }

        function modalClose() {
            $uibModalInstance.dismiss('cancel');
        }

        function cleanErrors(errorField, key) {
            errorField[key] = [];
        }

        function onChangeModifyType(opt){
            if (opt.value === self.modifyOwnPriceOpt) {
                self.modificationData.price = null;
            }

            if (opt.value === self.ownPriceOpt) {
                self.modificationData.value = null;
                self.modificationData.percentage = null;
            }
        }

        function onChangeModificator(opt){
            if (opt.value === self.percentageModificatorOpt) {
                self.modificationData.value = null;
            }

            if (opt.value === self.priceModificatorOpt) {
                self.modificationData.percentage = null;
            }
        }
    }
})();
